<input
  (keydown)="onKeyDown($event)"
  [errorStateMatcher]="errorStateMatcher"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [id]="id"
  [placeholder]="to.placeholder"
  [type]="'text'"
  matInput
/>
